import BaseService from "../baseService";
class Cidades extends BaseService {
  constructor(id) {
    const resource = "cidade";
    let relationship = { servicosPrestadosCsv: "servico-prestado-csv" };
    super(id, relationship, resource);
  }
}

export default (id) => new Cidades(id);
